import { z } from "zod";

export const markAsPickedUp = {
  input: z
    .object({ fulfillmentGroupIds: z.array(z.string()) })
    .or(z.object({ batchId: z.string() })),
  output: z.object({}),
};
